export const EMAIL_PATTERN =
  /^[A-Za-z0-9]+(?:[-\+._][A-Za-z0-9]+)*@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/
export const NUMBER_PATTERN = /^[0-9]+$/;
